/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: default-artwork-maps-grid-component.ts
 *
 * Created by kyang on 2019-04-29.
 */

function DefaultMapsGridController (
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $scope: JS5Object,
    uiGridConstants: JS5Object
) {

    //======//
    // Grid //
    //======//

    let gridOptionsReadyDeferred = $q.defer();
    let gridApiReadyDeferred = $q.defer();

    let gridOptionsReadyPromise = gridOptionsReadyDeferred.promise;
    let gridApiReadyPromise = gridApiReadyDeferred.promise;

    //
    // This promise will resolve when the grid is ready for data
    // and API calls.
    //
    let gridReadyPromise = $q.all([
        gridOptionsReadyPromise,
        gridApiReadyPromise
    ]);

    const dropdownSortByName = (a: JS5Object, b: JS5Object) => {
        return _.toLower(_.get(a, 'name')).localeCompare(_.toLower(_.get(b, 'name')));
    };

    const colDefs: JS5Object[] = [
        {
            cellTemplate: 'components/visual/grid/check-mark-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            enableColumnResizing: false,
            field: 'checkMark',
            fieldName: 'Selection',
            headerCellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/header-check-mark-row-count-template.html',
            width: 55,
        },
        {
            cellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/artwork-accept-profile-cell-template.html',
            enableColumnMenu: false,
            enableSorting: true,
            field: 'artworkAcceptProfile',
            displayName: 'MAPs',
            sort: {
                direction: uiGridConstants.ASC,
                priority: 1
            },
            sortable: true,
            sortingAlgorithm: dropdownSortByName,
            width: 455,
        },
        {
            cellTemplate: 'components/grids/default-artwork-maps-grid/cell-templates/category-type-cell-template.html',
            enableColumnMenu: false,
            enableSorting: false,
            field: 'artworkAcceptProfile',
            displayName: 'Category Type',
            width: 200,
        }
    ];

    this.gridOptions = {
        selectionRowHeaderColName: 'Selection',
        rowSelection: true,
        enableRowHeaderSelection: false,
        enableSelectAll: true,
        enableColumnResizing: false,
        enablePaginationControls: false,
        enableFullRowSelection: true,
        enableSorting: true,
        rowHeight: 26,
        multiSelect: true,
        minRowsToShow: 7,
        columnDefs: colDefs,
        data: [],
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            gridApiReadyDeferred.resolve(true);
        }
    };

    this.areAllRowsSelected = () => {
        return this.gridApi.selection.getSelectedCount() >= this.gridOptions.data.length;
    };

    this.onSelectAllToggled = ($event: JS5Object) => {
        if (this.areAllRowsSelected()) {
            this.gridApi.selection.clearSelectedRows($event);

        } else {
            this.gridApi.selection.selectAllRows($event);
        }
    };

    //=======================//
    // Grid Row Manipulation //
    //=======================//

    this.addDefaultMap = () => {
        this.gridOptions.data.push({
            acceptProfile: null,
            packageCategoryType: _.find(this.categoryTypes, {name: 'Both'})
        });
        this.onArtworkAcceptProfilesChanged({validAcceptProfiles: null});
    };

    this.removeDefaultMaps = () => {
        let selectedRows = this.gridApi.selection.getSelectedRows();
        if (selectedRows.length > 0) {
            _.pullAll(this.gridOptions.data, selectedRows);
            this.gridApi.selection.clearSelectedRows();
        }
        this.onArtworkAcceptProfilesChanged({validAcceptProfiles: getValidAcceptProfiles()});
    };


    //================//
    // Template Logic //
    //================//

    this.onArtworkRowChanged = (rowEntity: JS5Object) => {
        this.onArtworkAcceptProfilesChanged({validAcceptProfiles: getValidAcceptProfiles()});
    };

    const isValid = () => {
        let profileIdsFound: JS5Object = {};

        return _.every(this.gridOptions.data, (rowEntity: JS5Object) => {
            // Each profile can only be added once
            const profileId = _.get(rowEntity, 'acceptProfile.id');
            if (profileIdsFound[profileId]) {
                return false;
            }
            profileIdsFound[profileId] = true;
            return !!rowEntity.acceptProfile;
        });
    };

    const getValidAcceptProfiles = () => {
        if (isValid()) {
            return this.gridOptions.data;
        } else {
            return null;
        }
    };

    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onChanges = () => {
        gridReadyPromise.then(() => {
            _.invoke(this.gridApi, 'selection.clearSelectedRows');
            this.gridOptions.data = this.initialArtworkAcceptProfiles || [];
        });
    };

    this.availableArtworkAcceptProfiles = [];
    this.gridApi = null;

    this.$onInit = () => {
        gridOptionsReadyDeferred.resolve(true);
    };
}

angular.module('prism-ui.components').component(
    'defaultMapsGrid',
    {
        bindings: {
            onArtworkAcceptProfilesChanged: '&',
            categoryTypes: '<',
            availableArtworkAcceptProfiles: '<',
            initialArtworkAcceptProfiles: '<'
        },
        controller: DefaultMapsGridController,
        templateUrl: 'components/grids/default-artwork-maps-grid/default-artwork-maps-grid-template.html'
    });
